<div
    class="banner row align-center gap-8 justify-center"
    *ngIf="!showDialogHeader"
>
    <span>Created with:</span><img src="images/logo_name.svg" alt="" />
    <rr-btn type="Primary" size="Small" (click)="gotologin()"
        >sign up for free</rr-btn
    >
</div>

<div class="header row space-between align-center" *ngIf="showDialogHeader">
    <h1>Preview</h1>
    <div class="row gap-8 align-center">
        <!-- <div class="exportmenue" class="pointer">
            <div class="row gap-8" (click)="showMenue = !showMenue">
                <span>Exports</span>
                <rr-icon name="chevron-down"></rr-icon>
            </div>
            <div class="menue-main" *ngIf="showMenue">
                <div
                    class="menue-overlay"
                    (click)="showMenue = !showMenue"
                ></div>
                <div class="menue-content col gap-4">
                    <div class="menue-item" (click)="exportAsPdf()">
                        Export as PDF
                    </div>
                    <div class="menue-item" (click)="exportAsMiro()">
                        Export as Miro
                    </div>
                </div>
            </div>
        </div> -->
        <rr-btn
            type="Primary"
            size="Small"
            iconStart="share"
            (click)="shareAsset()"
            >Share</rr-btn
        >
        @if(editContent === false){
        <rr-btn
            type="Secondary"
            size="Small"
            iconStart="edit"
            (click)="editPage()"
            >Edit Page</rr-btn
        >}@else { @if(unsavedContent === true){
        <rr-btn
            (click)="cancelEdit()"
            size="Small"
            type="Secondary"
            iconStart="close"
            >Cancel</rr-btn
        >
        <rr-btn
            type="Primary"
            size="Small"
            iconStart="save"
            (click)="saveContent()"
            >Save changes</rr-btn
        >
        }@else{
        <rr-btn
            type="Secondary"
            size="Small"
            iconStart="close"
            (click)="editPage()"
            >Close edit</rr-btn
        >
        } }
    </div>
</div>
<div class="row area">
    <app-html-template-view
        [content]="content"
        [name]="assetName"
        (contentChanged)="onContentChanged($event)"
        #htmlTemplateView
        class="content"
    ></app-html-template-view>
    <!-- <div #container class="content" [innerHTML]="content"></div> -->
    @if(editContent === true){
    <div class="editarea col gap-16">
        <div class="col gap-4">
            <h2>Edit your pictures</h2>
            <div>click on an image to edit</div>
        </div>
        <div class="row imagearea w100 gap-8 wrap">
            <div
                *ngFor="let img of imgAssets"
                class="image-item card"
                [style]="'background-image: url(' + img + ')'"
                (click)="editImage(img)"
            ></div>
        </div>
    </div>
    }
</div>
@if(isLoading === true){
<rr-spinner></rr-spinner>
}
